<style scoped>

</style>
<template>
    <div>
        <div class="line">
            <Button type="primary" @click="refresh">刷新</Button>
        </div>
        <Table :columns="log_columns" :data="logs" :loading="loading"></Table>
        <div class="line paginate-fix-bottom" v-show="page_info.total">
            <Page
                show-total
                show-elevator
                :current="page_info.current"
                :total="page_info.total"
                :page-size="page_info.page_size"
                @on-change="pageChange">
            </Page>
        </div>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    import UserFlowBase from '../../components/flow/user_flow_base';
    import ExpenseGroupExportLogExpand from './expense_group_export_log_expand';
    import {mapGetters} from "vuex";
    export default {
        components: { UserFlowBase, ExpenseGroupExportLogExpand },
        data(){
            return {
                params: {
                    search: '',
                    page: 1
                },
                page_info: {
                    current: 1,
                    total: 0,
                    page_size: 1
                },
                loading: false,
                logs: [],
                log_columns: [
                    {
                        title: '展开',
                        align: 'center',
                        type: 'expand',
                        width: 60,
                        render: (h, params) => {
                            let row = params.row;
                            return h(ExpenseGroupExportLogExpand, {
                                props: {
                                    log: row
                                }
                            })
                        }
                    },
                    {
                        title: '公司',
                        key: 'company',
                        align: 'center',
                        width: 70,
                    },
                    {
                        title: '导出文件名',
                        key: 'filename',
                        align: 'center',
                        width: 180,
                    },
                    {
                        title: '导出时间',
                        key: 'export_time',
                        align: 'center',
                        width: 80,
                    },
                    {
                        title: '单数',
                        key: 'count',
                        align: 'center',
                        width: 60,
                        render: (h, params)=>{
                            return h('span', params.row.expense_group_ids.length);
                        }
                    },
                    {
                        title: '付款账号',
                        key: 'count',
                        align: 'center',
                        render: (h, params)=>{
                            let row = params.row;
                            let bank = row.expense_payment_bank;
                            if(bank){
                                return h('div', [
                                    h('div', `${bank.bank} - ${bank.bank_number}`),
                                    h('div', bank.account),
                                    h('div', bank.bank_branch)
                                ]);
                            }else{
                                return h('span', '-');
                            }
                        }
                    },
                    {
                        title: '总金额',
                        key: 'total_price',
                        align: 'right',
                        width: 120,
                        render: (h, params)=>{
                            let row = params.row;
                            return h('span', `￥ ${Util.formatPrice(row.total_price)}`);
                        }
                    },
                    {
                        title: '状态',
                        align: 'center',
                        width: 80,
                        render: (h, params)=>{
                            let row = params.row;
                            let expense_group_export_check = row.expense_group_export_check;
                            if(expense_group_export_check && expense_group_export_check.status > -1){
                                if(expense_group_export_check.del){
                                    return h('span', {
                                        'class': {
                                            'color-error': true
                                        }
                                    }, '已撤销');
                                }
                                if(expense_group_export_check.status === 0){
                                    return h('span', {
                                        'class': {
                                            'color-info': true
                                        }
                                    }, '待付款');
                                }else if(expense_group_export_check.status === 9){
                                    return h('span', {
                                        'class': {
                                            'color-success': true
                                        }
                                    }, '已完成');
                                }
                            }
                            return h('span', '-');
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        width: 80,
                        render: (h, params)=>{
                            let row = params.row;
                            let expense_group_export_check = row.expense_group_export_check;
                            if(!row.filename){
                                return h('span', '-');
                            }
                            let items = [];
                            if(!expense_group_export_check){
                                items.push(h('DropdownItem', {
                                    props: {
                                        name: 'submit'
                                    }
                                }, '提交审核'))
                            }
                            items.push(h('DropdownItem', {
                                props: {
                                    name: 'reload'
                                }
                            }, '查看清单'));
                            if(expense_group_export_check && !expense_group_export_check.del && expense_group_export_check.status === 0){
                                items.push(h('DropdownItem', {
                                    props: {
                                        name: 'del',
                                        divided: true,
                                    }
                                }, '撤销'));
                            }

                            let ret = [
                                h('Dropdown', {
                                    props: {
                                        transfer: true,
                                        trigger: 'click'
                                    },
                                    on: {
                                        'on-click': (name)=>{
                                            this.handleEvent(name, row);
                                        }
                                    }
                                }, [
                                    h('Button', {
                                        props:{
                                            size: 'small'
                                        }
                                    }, [
                                        h('span', '操作 '),
                                        h('Icon', {props: {type: 'arrow-down-b'}})
                                    ]),
                                    h('DropdownMenu', {slot: 'list'}, items)
                                ])
                            ];
                            return h('div', ret);
                        }
                    },
                ]
            }
        },
        computed: {
            ...mapGetters({
                companies: 'async/companies',
                companies_hash: 'async/companies_hash',
                teams: 'async/root_teams',
                teams_hash: 'async/root_teams_hash',
            }),
        },
        created(){
            //
        },
        mounted(){
            this.getExportLogs();
        },
        methods: {
            refresh(){
                this.params.page = 1;
                this.getExportLogs();
            },
            pageChange(new_page){
                this.params.page = new_page;
                this.getExportLogs();
            },
            getExportLogs(){
                this.loading = true;
                Util.ajax.get(Util.api.recent_expense_group_export, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.loading = false;
                    this.logs = [];
                    if(res.code === 1){
                        let data = res.data;
                        data.logs.forEach((log)=>{
                            this.preProcessLog(log);
                            this.logs.push(log);
                        });
                        this.page_info.current = data.cur_page;
                        this.page_info.page_size = data.per_page;
                        this.page_info.total = data.total_count;
                    }else{
                        this.$Modal.error({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.loading = false;
                    console.log(e);
                    this.$Modal.error({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            preProcessLog(log){
                log.export_time = moment(log.created_at).format('YYYY-MM-DD HH:mm:ss');
                log.company = this.companies_hash[log.company_id].short_name;
                log.expense_group_ids = JSON.parse(log.expense_group_ids);
                return log;
            },
            handleEvent(event_name, log){
                console.log(event_name, log);
                switch (event_name){
                    case 'submit':
                        this.submitLog(log);
                        break;
                    case 'reload':
                        this.$emit('reload', log.expense_group_ids);
                        break;
                    case 'del':
                        this.delCheck(log);
                        break;
                    default:
                        console.error('未定义事件: ' + event_name);
                        break;
                }
            },
            submitLog(log){
                let expense_group_export_check = log.expense_group_export_check;
                if(expense_group_export_check) return;
                this.$Modal.confirm({
                    title: '提示',
                    content: '你确定要提交吗?',
                    onOk: ()=>{
                        if(this.loading) return;
                        this.loading = true;
                        Util.ajax.post(Util.api.check_expense_group_export, {
                            id: log.id
                        }).then((response)=>{
                            return response.data;
                        }).then((res)=>{
                            this.loading = false;
                            if(res.code === 1){
                                let data = res.data;
                                this.preProcessLog(data.log);
                                Util.insertOrUpdateArrayItem(this.logs, data.log);
                            }else{
                                setTimeout(()=>{
                                    this.$Modal.error({
                                        title: '错误',
                                        content: res.msg
                                    });
                                }, 600);
                            }
                        }).catch((e)=>{
                            this.loading = false;
                            this.$Modal.error({
                                title: '错误',
                                content: e.message
                            });
                        });
                    }
                });
            },
            delCheck(log){
                let expense_group_export_check = log.expense_group_export_check;
                if(!expense_group_export_check) return;
                this.$Modal.confirm({
                    title: '提示',
                    content: '你确定要撤销吗?',
                    onOk: ()=>{
                        if(this.loading) return;
                        this.loading = true;
                        Util.ajax.post(Util.api.expense_group_export_check_delete, {
                            id: expense_group_export_check.id
                        }).then((response)=>{
                            return response.data;
                        }).then((res)=>{
                            this.loading = false;
                            if(res.code === 1){
                                expense_group_export_check.del = true;
                            }else{
                                setTimeout(()=>{
                                    this.$Modal.error({
                                        title: '错误',
                                        content: res.msg
                                    });
                                }, 600);
                            }
                        }).catch((e)=>{
                            this.loading = false;
                            this.$Modal.error({
                                title: '错误',
                                content: e.message
                            });
                        });
                    }
                });
            }
        }
    }
</script>
